"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMeasurementPartnerToJSON = exports.MobileMeasurementPartnerFromJSONTyped = exports.MobileMeasurementPartnerFromJSON = exports.MobileMeasurementPartner = void 0;
/**
 * The available mobile measurement partners.
 * @export
 */
exports.MobileMeasurementPartner = {
    Kochava: 'KOCHAVA',
    AppsFlyer: 'APPS_FLYER'
};
function MobileMeasurementPartnerFromJSON(json) {
    return MobileMeasurementPartnerFromJSONTyped(json, false);
}
exports.MobileMeasurementPartnerFromJSON = MobileMeasurementPartnerFromJSON;
function MobileMeasurementPartnerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MobileMeasurementPartnerFromJSONTyped = MobileMeasurementPartnerFromJSONTyped;
function MobileMeasurementPartnerToJSON(value) {
    return value;
}
exports.MobileMeasurementPartnerToJSON = MobileMeasurementPartnerToJSON;
